// extracted by mini-css-extract-plugin
export default {"grid":"CardList_grid__S+v3D","no-card-list-text-box":"CardList_no-card-list-text-box__ePILs"};